import { useQueryClient } from "@tanstack/react-query";
import { getGetAnalysisQueryKey, useTakeBackAnalysisEditAccess } from "Infrastructure/ApiZfp/AnalyzerApi";
import { SharedAnalysisNotFoundErrorCode } from "Infrastructure/ApiZfp/Schema";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { useContext } from "react";
import { toast } from "sonner";
import { AnalysisDetailContext } from "../AnalysisDetailContext";

export const useTakeBackEditAccess = () => {
  const { t } = useResource();
  const { analysisId, versionId } = useContext(AnalysisDetailContext);
  const queryClient = useQueryClient();

  const { mutate, isPending } = useTakeBackAnalysisEditAccess({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: getGetAnalysisQueryKey(analysisId, versionId) });
        toast.success(t(Resources.AnalysisDetail.Sharing.Toast.TakenBack));
      },
      onError: (error) => {
        toast.error(
          error?.code === SharedAnalysisNotFoundErrorCode.nsure_agent_not_found
            ? t(Resources.AnalysisDetail.Sharing.Toast.TakeBackNsureAccountMissing)
            : t(Resources.AnalysisDetail.Toast.ActionError),
        );
      },
    },
  });

  return {
    takeBack: (options?: { onSettled?: () => void }) => mutate({ analysisId, versionId }, options),
    isTakingBack: isPending,
  };
};
